// extracted by mini-css-extract-plugin
export var aboveInput = "_mv-0";
export var actionButton = "_mv-5";
export var actionButtonContainer = "_mv-1";
export var actionIcon = "_mv-6";
export var aiInfoContainer = "_mv-2";
export var attachmentWrapper = "_mv-7";
export var bold = "_mv-3";
export var checkIcon = "_mv-8";
export var clickingRecipientBar = "_mv-11";
export var commentThreadSwitch = "_mv-a";
export var draftImage = "_mv-b";
export var draftImageContainer = "_mv-c";
export var draftImages = "_mv-e";
export var editButton = "_mv-g";
export var editor = "_mv-f";
export var editorContainer = "_mv-y";
export var editorErrorTooltipWrapper = "_mv-9";
export var headerDivider = "_mv-h";
export var icon = "_mv-i";
export var info = "_mv-j";
export var internal = "_mv-n";
export var internalDivider = "_mv-k";
export var internalMessage = "_mv-l";
export var messageInputCard = "_mv-m";
export var messageInputForm = "_mv-o";
export var messageInputFormInternal = "_mv-p";
export var options = "_mv-q";
export var publicMessageCustomer = "_mv-s";
export var publicMessageMerchant = "_mv-r";
export var removeImageButton = "_mv-d";
export var replyButtons = "_mv-t";
export var showSignatureButton = "_mv-u";
export var spinner = "_mv-v";
export var verticalButtonDivider = "_mv-4";
export var visibilitySelector = "_mv-w";
export var warning = "_mv-x";
export var wrappingText = "_mv-z";
export var writingInternalNoteTopBorder = "_mv-10";